import React from "react";
import { Link } from "react-router-dom";
import back from "../../assets/service-images/backimg-service-strategic.webp";
import image from "../../assets/home-images/Group3.svg";
import strategiclogo1 from "../../assets/service-images/strategic-plan-logo1.svg";
import strategiclogo2 from "../../assets/service-images/strategiclogo2.svg";
import strategiclogo3 from "../../assets/service-images/strategiclogo3.svg";

function StrategicPlanning() {
  return (
    <>
      {/* Section ! */}

      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${back})` }}
      >
        <h1
          data-aos="fade-down"
          className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-2/5 xl:w-[1021px]"
        >
          Is your ServiceNow instance optimized for your business needs?
        </h1>

        <p
          data-aos="fade-down"
          className="text-white text-sm     w-full md:w-2/3 lg:w-1/2 xl:w-[754px]"
        >
          Your ServiceNow instance holds endless potential. At Tekpossible, we
          specialize in discovering these opportunities, selecting, and
          implementing the right ServiceNow tools and integrations to help you
          achieve your unique business objectives.
        </p>

        <Link
          data-aos="zoom-in"
          data-aos-delay="300"
          to="/contact-us"
          className="w-fit bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-8 lg:py-3 rounded-lg text-white hover:bg-white hover:text-[#C32A7C] transition-colors duration-300 text-sm sm:text-base md:text-lg lg:text-lg text-center whitespace-nowrap"
        >
          Contact Us
        </Link>
      </div>

      {/* Section 2 */}
      <div className="bg-[#FFFFFF] mt-10">
        <div className="flex flex-col items-center text-center gap-4 py-8 px-6">
          <h1
            className="text-[#1A5298] font-bold text-lg md:text-3xl"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Our Simple 3-Step Consulting Process
          </h1>
          <p
            className="text-[#000] text-sm md:text-base max-w-[90%] md:max-w-[860px]"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Our team of seasoned ServiceNow consultants offers in-depth platform
            knowledge and a wealth of IT experience, allowing them to pinpoint
            opportunities, resolve your toughest challenges, and provide
            guidance on industry standards.
          </p>
        </div>

        <div className="bg-white px-6 py-5">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            <div
              className="p-6 flex flex-col items-center text-center justify-between h-full"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <h2 className="text-[#000] text-lg md:text-xl font-semibold max-w-[253px]">
                Comprehensive Assessment
              </h2>
              <div className="mt-5 flex items-center">
                <img
                  className="object-contain w-20"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
              <p className="text-black text-sm md:text-base mt-5 max-w-[361px]">
                Our deep dive into your ServiceNow instance covers all aspects
                of its functionality, processes, and technical architecture,
                providing us with invaluable insights.
              </p>
            </div>

            <div
              className="p-6 flex flex-col items-center text-center justify-between h-"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <h2 className="text-[#000] text-lg md:text-xl font-semibold max-w-[253px]">
                Key Insights & Observations
              </h2>
              <div className="mt-5 flex items-center">
                <img
                  className="object-contain w-20"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
              <p className="text-black text-sm md:text-base mt-5 max-w-[361px]">
                Working closely with your team, we develop a tailored strategic
                roadmap with actionable steps to optimize and enhance your
                architecture.
              </p>
            </div>

            <div
              className="p-6 flex flex-col items-center text-center justify-between h-full"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <h2 className="text-[#000] text-lg md:text-xl font-semibold max-w-[253px]">
                Personalized Recommendations
              </h2>
              <div className="mt-5 flex items-center">
                <img
                  className="object-contain w-20"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
              <p className="text-black text-sm md:text-base mt-5 max-w-[361px]">
                Working closely with your team, we develop a tailored strategic
                roadmap with actionable steps to optimize and enhance your
                architecture.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Sectin 3 */}

      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF] mt-10">
        <div className="relative">
          <div className="text-center mb-5 px-6">
            <h1
              className="text-black font-semibold text-3xl"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Tekpossible Success Story
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 px-6 gap-6 py-5">
            {[
              {
                img: strategiclogo1,
                title: "The Challenge",
                desc: "A $22B healthcare-oriented financial technology company faced operational roadblocks due to insufficient visibility and agility. They partnered with Tekpossible to overcome these challenges.",
              },
              {
                img: strategiclogo2,
                title: "The Strategy",
                desc: "Our three-step process culminated in comprehensive reports detailing their business, technical, and functional status, complemented by a detailed timeline, actionable recommendations, and a strategic roadmap for their ServiceNow products.",
              },
              {
                img: strategiclogo3,
                title: "The Result",
                desc: "ServiceNow Change Management, DevOps, SAM Pro, CMDB, HAM, SIR, and VR were successfully implemented and seamlessly integrated by our team.",
              },
            ].map((service, index) => (
              <div
                data-aos="fade-up"
                data-aos-delay="500"
                key={index}
                className="sec3 flex flex-col items-center text-center mt-20 max-w-[918px] mx-auto transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col items-center rounded border bg-[#FFFFFF] flex-1 w-full hover:transition-all duration-300 h-full">
                  <img
                    className="-mt-10 transform transition-transform duration-300  object-contain"
                    src={service.img}
                    alt={service.title}
                  />
                  <h3 className="text-lg font-semibold mt-4 text-[#000] px-4">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black mt-2 flex-grow px-4 mb-10 max-w-[773px]">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 4 */}

      <div className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6">
        <div
          className="flex flex-col items-center text-center px-4 md:px-6"
          data-aos="fade-down-right"
        >
          {/* Heading */}
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/3 xl:w-2/3">
            Work smarter, not harder with Tekpossible
          </h1>

          {/* Button */}
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                                         hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                                         text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </>
  );
}

export default StrategicPlanning;
